function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "masks",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_8_",
  d: "M5,11A4.978,4.978,0,0,1,0,6.056V0H10V6.056A4.977,4.977,0,0,1,5,11ZM2.134,6.636a2.174,2.174,0,0,0,.907,1.481A3.3,3.3,0,0,0,5,8.729a3.3,3.3,0,0,0,1.958-.612,2.174,2.174,0,0,0,.907-1.481H6.412A1.561,1.561,0,0,1,5,7.325a1.562,1.562,0,0,1-1.413-.689ZM7.323,2.272A1.162,1.162,0,1,0,8.5,3.433,1.169,1.169,0,0,0,7.323,2.272Zm-4.647,0A1.162,1.162,0,1,0,3.851,3.433,1.169,1.169,0,0,0,2.677,2.272Z",
  transform: "translate(6)"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_13_",
  d: "M4.947,11A4.951,4.951,0,0,1,0,6.056V0H4.571V2.84a6.346,6.346,0,0,0,.767,3.021l.185.34-.387-.02c-.07,0-.13-.006-.189-.006a3.24,3.24,0,0,0-1.939.612,2.177,2.177,0,0,0-.9,1.481H3.55a1.541,1.541,0,0,1,1.4-.689,1.539,1.539,0,0,1,1.4.689H7.635l.051.031a6.4,6.4,0,0,0,1.033.494L9,8.9l-.187.234A4.928,4.928,0,0,1,4.947,11Zm-2.3-8.728A1.161,1.161,0,1,0,3.811,3.433,1.163,1.163,0,0,0,2.649,2.272Z",
  transform: "translate(0 3)"
}));

var SvgIconMasks = function SvgIconMasks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "#878787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMasks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-masks.9625ecfb.svg";
export { ForwardRef as ReactComponent };